import { useState, useEffect, useContext } from 'react'
import ContextStates from '../../context/ContextStates'
import axios from 'axios'
import { Url } from '../Url'
import { FaEye, FaLock, FaTrash } from 'react-icons/fa'

const ListadoRepartos = () => {
    const [repartos, setRepartos] = useState([])
    const [usuarios, setUsuarios] = useState([])
    const [usuario, setUsuario] = useState(0)
    const [total, setTotal] = useState(0)
    const [fechaInicio, setFechaInicio] = useState('')
    const [fechaFin, setFechaFin] = useState('')
    const [estado, setEstado] = useState(true)
    const { setRepartoSelected, setFormView, setViewOpen, modify, idUsuario } = useContext(ContextStates)

    useEffect(() => {
        const calcTotal = () => {
            let t = 0;
            if (typeof repartos !== 'undefined') {
                repartos.forEach(element => {
                    t = t + parseInt(element.total)
                });
                setTotal(t)
            }
        }
        calcTotal()
    }, [repartos])

    useEffect(() => {
        const getUsuarios = async () => {
            const formData = new FormData()
            formData.append('usuariocero', 1);
            formData.append('local', 1);
            try {
                const results = await axios({
                    url: Url + 'api/listUsrs.php',
                    method: 'POST',
                    data: formData,
                })
                console.log("usuarios ", results)
                setUsuarios(results.data.results);
                setUsuario(results.data.results[0].id)
            } catch (e) {
                console.log(e)
            }
        }
        getUsuarios()
    }, [])

    useEffect(() => {
        const consultaRepartos = async () => {
            let estRep = '';
            if (estado) {
                estRep = 0;
            }
            const formData = new FormData()
            formData.append('fechainicio', fechaInicio)
            formData.append('fechafin', fechaFin)
            formData.append('usuario', usuario)
            formData.append("idusuario", idUsuario)
            formData.append("estado", estRep)

            try {
                const response = await axios({
                    url: Url + 'api/listadoRepartos.php',
                    method: 'POST',
                    data: formData,
                })
                console.log(response)
                setRepartos(response.data.results)
            } catch (e) {
                console.log(e)
            }
        }
        consultaRepartos()
    }, [fechaInicio, fechaFin, modify, usuario, estado])

    const handleView = (item) => {
        setRepartoSelected(item)
        setFormView(205)
        setViewOpen(true)
    }

    const handleEdit = (item) => {
        setRepartoSelected(item)
        setFormView(206)
        setViewOpen(true)
    }
    const handleClose = (item) => {
        setRepartoSelected(item)
        setFormView(208)
        setViewOpen(true)
    }

    const handleDel = (item) => {
        setRepartoSelected(item)
        setFormView(207)
        setViewOpen(true)
    }

    return (
        <div className="w-full py-6 px-4 animate-fadeIn">
            {/* Title */}
            <h2 className='text-slate-800 font-extrabold text-3xl tracking-tight text-center mb-8 mt-2'>Repartos</h2>
            
            {/* Filtros Container */}
            <div className="w-full md:w-11/12 max-w-4xl mx-auto bg-white/85 backdrop-blur-md border border-slate-200/80 shadow-sm rounded-2xl p-6 mb-8 transition-all">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                    <div>
                        <label htmlFor='fechainicio' className="block text-slate-500 font-semibold text-xs tracking-wider uppercase mb-1.5">Fecha de Inicio</label>
                        <input 
                            type='date' 
                            className='w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 text-sm transition-all text-slate-700' 
                            id='fechainicio' 
                            value={fechaInicio} 
                            onChange={(e) => setFechaInicio(e.target.value)} 
                        />
                    </div>
                    <div>
                        <label htmlFor='fechafin' className="block text-slate-500 font-semibold text-xs tracking-wider uppercase mb-1.5">Fecha de Fin</label>
                        <input 
                            type='date' 
                            className='w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 text-sm transition-all text-slate-700' 
                            id='fechafin' 
                            value={fechaFin} 
                            onChange={(e) => setFechaFin(e.target.value)} 
                        />
                    </div>
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-5">
                    {usuarios && (
                        <div>
                            <label htmlFor='sUsuario' className="block text-slate-500 font-semibold text-xs tracking-wider uppercase mb-1.5">Repartidor</label>
                            <select
                                className='w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 text-sm transition-all text-slate-700'
                                id='sUsuario'
                                value={usuario}
                                onChange={(e) => setUsuario(e.target.value)}
                            >
                                {usuarios.map((item, index) => (
                                    <option key={index} value={item.id}>{item.nombre}</option>
                                ))}
                            </select>
                        </div>
                    )}
                    <div className='flex items-end pb-1'>
                        <label className="flex items-center gap-2.5 select-none cursor-pointer text-slate-700 font-semibold text-sm uppercase tracking-wide">
                            <input 
                                className='w-4 h-4 text-indigo-600 border-slate-300 rounded focus:ring-indigo-500 transition-all' 
                                type='checkbox' 
                                onChange={() => setEstado(!estado)} 
                                checked={estado} 
                            />
                            <span>Solo Repartos abiertos</span>
                        </label>
                    </div>
                </div>
            </div>

            {/* Repartos Table */}
            {typeof repartos !== 'undefined' && repartos.length > 0 ? (
                <div className='w-full md:w-11/12 max-w-4xl mx-auto overflow-hidden border border-slate-200/60 shadow-sm rounded-2xl bg-white'>
                    <div className="overflow-x-auto">
                        <table className='w-full text-sm text-left border-collapse'>
                            <thead>
                                <tr className='bg-slate-50/75 border-b border-slate-200/80 text-slate-500 font-semibold text-xs tracking-wider uppercase text-center'>
                                    <th className="py-4 px-4 font-semibold text-center">Fecha</th>
                                    <th className="py-4 px-4 font-semibold text-center">Hora</th>
                                    <th className="py-4 px-4 font-semibold text-center">Repartidor</th>
                                    <th className='py-4 px-4 font-semibold text-center print:hidden w-80'>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    repartos.map((item, index) => {
                                        // Determine background color depending on state
                                        let rowBg = "bg-white hover:bg-slate-50/80";
                                        if (index % 2 !== 0) {
                                            rowBg = "bg-slate-50/40 hover:bg-slate-50/80";
                                        }

                                        return (
                                            <tr key={index} className={`transition-all border-b border-slate-100 text-center ${rowBg}`}>
                                                <td className="py-3.5 px-4 font-medium text-slate-800">{item.fecha}</td>
                                                <td className="py-3.5 px-4 text-slate-500 text-xs">{item.hora}</td>
                                                <td className="py-3.5 px-4 font-semibold text-slate-700">{item.apellido}</td>
                                                <td className="py-3.5 px-4 print:hidden">
                                                    <div className="flex justify-center items-center gap-2">
                                                        <button 
                                                            type="button"
                                                            className='flex items-center justify-center gap-1.5 bg-indigo-50 hover:bg-indigo-100 text-indigo-600 font-semibold px-3 py-2 rounded-xl text-xs transition-all shadow-sm w-full' 
                                                            onClick={() => handleView(item)}
                                                        >
                                                            <FaEye size={12} />
                                                            <span>Ver</span>
                                                        </button>
                                                        {item.estado === '0' && (
                                                            <button 
                                                                type="button"
                                                                className='flex items-center justify-center gap-1.5 bg-emerald-50 hover:bg-emerald-100 text-emerald-600 font-semibold px-3 py-2 rounded-xl text-xs transition-all shadow-sm w-full' 
                                                                onClick={() => handleClose(item)}
                                                            >
                                                                <FaLock size={12} />
                                                                <span>Cerrar</span>
                                                            </button>
                                                        )}
                                                        <button 
                                                            type="button"
                                                            className='flex items-center justify-center gap-1.5 bg-rose-50 hover:bg-rose-100 text-rose-600 font-semibold px-3 py-2 rounded-xl text-xs transition-all shadow-sm w-full' 
                                                            onClick={() => handleDel(item)}
                                                        >
                                                            <FaTrash size={12} />
                                                            <span>Eliminar</span>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            ) : (
                <div className="w-full md:w-11/12 max-w-4xl mx-auto bg-slate-50 border border-dashed border-slate-200 rounded-2xl p-10 text-center text-slate-500 font-medium">
                    No se encontraron repartos para los filtros seleccionados.
                </div>
            )}
        </div>
    )
}

export default ListadoRepartos